module.exports = __webpack_public_path__ + "static/media/EMJ Atcon_2026_Logo.84d9ae11.png";